import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ExportLabel from '../../../components/common/ExportLabel/Export';
import PageHeader from '../../../components/common/PageHeader/PageHeader';
import ArchiveSelectedItem from '../../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import './ReleaseNotes.css';
import InputBoxSmall from '../../../components/common/InputBox/InputBoxSmall';
import { publishReleaseNote } from '../../../services/ReleaseNotes/Releasenotesapi';
import IconUploadButton from '../../../components/common/InputBox/UploadIconBox';


const ReleaseNotesDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedItems, setSelectedItems] = useState([]);
    const [isPublishing, setIsPublishing] = useState(false);

    const note = location.state?.note;

    if (!note) {
        return (
            <div className='whole-container'>
                <div className='pagename-container'>
                    <span className='common-text fts-16'>No release note data found.</span>
                    <button className='cancel-btn-rn bg-white' onClick={() => navigate('/release-notes')}>
                        Back
                    </button>
                </div>
            </div>
        );
    }

    const { version, title, release_date, status, features, improvements, bug_fixes } = note;

    // ── Publish handler ───────────────────────────────────────────
    const handlePublish = async () => {
        if (isPublishing) return;
        setIsPublishing(true);
        try {
            const result = await publishReleaseNote(note.id);
            if (result) {
                alert('Release note published successfully!');
                navigate('/release-notes');
            }
        } finally {
            setIsPublishing(false);
        }
    };
    const capitalize = (text) =>
        text ? text.charAt(0).toUpperCase() + text.slice(1) : '';

    return (
        <div className='whole-container'>
            <div className='top-heading'>
                <PageHeader
                    pageName=" Engagement / Release Notes /"
                    nestedpageName="Details"
                    linkTo="/release-notes"
                />
                {/* <div className='export-container'>
                    <ArchiveSelectedItem selectedItems={selectedItems} />
                    <ExportLabel />
                </div> */}
            </div>
            <div className='pagename-container'>
                <div className='page-name'>
                    <h1 className='common-text fts-22 ftw-6 blue'>Release Note Details</h1>
                </div>
            </div>
            <div className='table-container'>
                <div className='add-release-note-container'>
                    <div className='release-basic-container'>
                        <div className='release-basic-header'>
                            <span className='release-header-title'>Basic Information</span>
                        </div>
                        <div className='release-basic-content'>
                            <div className='release-version-container'>
                                <InputBoxSmall label="Version" defaultValue={version} readOnly />
                            </div>
                            <div className='release-basic-description-container'>
                                <InputBoxSmall label="Release title" defaultValue={title} readOnly />
                                <InputBoxSmall label="Release date" type='small-date' defaultValue={release_date} readOnly />
                                <InputBoxSmall label="Status" defaultValue={capitalize(status)} readOnly />
                            </div>
                            <div className='release-basic-bt-text'>
                                <span>This title is for internal use only and will not be shown to users.</span>
                            </div>
                        </div>
                    </div>
                    <div className='release-feature-container'>
                        <div className='release-feature-header'>
                            <span className='release-header-title'>Feature Information</span>
                        </div>
                        <div className='release-feature-content-container'>
                            <div className='release-feature-titles'>
                                <span>Icon</span>
                                <span>Feature Name</span>
                                <span>Description (40–50 characters)</span>
                            </div>
                            <div className='release-feature-content'>
                                {features?.length > 0 ? features.map((item) => (
                                    <div className='release-feature-row' key={item.id}>
                                        <div className='release-feature-content-left-row'>
                                            <IconUploadButton icon={item.image} readOnly />
                                            <span>{item.name}</span>
                                            <span>{item.description}</span>
                                        </div>
                                    </div>
                                )) : (
                                    <p className='common-text fts-14' style={{ padding: '8px 0', color: '#888' }}>No features added.</p>
                                )}
                            </div>
                        </div>
                        <hr />
                        <div className='release-btm-container'>
                            <div className='release-btm-left'>
                                <div className='release-btm-left-title'><span>Improvements</span></div>
                                <div className='release-btm-left-content'>
                                    {improvements?.length > 0 ? improvements.map((item) => (
                                        <div className='release-btm-left-content-row' key={item.id}>
                                            <span className='imp-icon-left'></span>
                                            <span className='release-btm-text-left'>{item.text}</span>
                                        </div>
                                    )) : (
                                        <p className='common-text fts-14' style={{ color: '#888' }}>No improvements added.</p>
                                    )}
                                </div>
                            </div>
                            <div className='release-btm-right'>
                                <div className='release-btm-right-title'><span>Bug Fixes</span></div>
                                <div className='release-btm-right-content'>
                                    {bug_fixes?.length > 0 ? bug_fixes.map((item) => (
                                        <div className='release-btm-right-content-row' key={item.id}>
                                            <span className='bug-icon-left'></span>
                                            <span className='release-btm-text-left'>{item.text}</span>
                                        </div>
                                    )) : (
                                        <p className='common-text fts-14' style={{ color: '#888' }}>No bug fixes added.</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* ── ACTION BUTTONS ─────────────────────────────── */}
                        <div className='release-final-btn-container'>
                            <button
                                className='cancel-btn-rn bg-white'
                                onClick={() => navigate('/release-notes')}
                            >
                                Back
                            </button>
                            <button
                                className='save-draft-btn-rn'
                                onClick={() => navigate(`/release-notes/edit/${note.id}`, { state: { note } })}
                            >
                                Edit
                            </button>
                            {status !== 'published' && (
                                <button
                                    className='release-final-btn'
                                    onClick={handlePublish}
                                    disabled={isPublishing}
                                >
                                    {isPublishing ? 'Publishing...' : 'Publish Release Note'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReleaseNotesDetail;